import CollapsibleBioV2 from './CollapsibleBioV2';
import CollapsibleBio from './CollapsibleBio';

import { withFeatureBranch } from '@wix/da-shared-react/pkg/redux/flags';
export default withFeatureBranch({
  collapsible_bio_v2: CollapsibleBioV2,
})(CollapsibleBio);
